// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {Text} from '../../comp/text';
import {Popup} from '../../comp/popup';
import './raw_mongo_device.less';

export function Raw_mongo_device({data, show, on_close}){
    return <Popup title="Raw mongo device object" show={show}
      on_close={on_close} hide_actions>
      <Text.s mono className="ea_raw_mongo_device">
        {data}
      </Text.s>
    </Popup>;
}
